import { quotation_state } from '../../../quotations/data/quotation-states.service';
import { QuotationsDashboardData } from './types';

type MockQuotation = {
  id: number
  number: string
  customerName: string
  projectName: string
  stateId: number
  totalPrice: number
  validToDate: string
  daysUntilExpiration: number
}

const EXPIRING_WITHIN_DAYS = 30;

export function createQuotationsMockData(): QuotationsDashboardData {
  const quotations = createQuotations();
  const openStateIds = [
    quotation_state.draft,
    quotation_state.approved,
    quotation_state.send,
    quotation_state.negotiating
  ];
  const open = quotations.filter(quotation => openStateIds.includes(quotation.stateId));
  const expiringSoon = open.filter(quotation =>
    quotation.daysUntilExpiration >= 0
    && quotation.daysUntilExpiration <= EXPIRING_WITHIN_DAYS
  );
  const accepted = quotations.filter(
    quotation => quotation.stateId === quotation_state.accepted
  );

  return {
    summary: {
      open: {
        count: open.length,
        totalPrice: sum(open)
      },
      expiringSoon: {
        count: expiringSoon.length,
        totalPrice: sum(expiringSoon),
        withinDays: EXPIRING_WITHIN_DAYS
      },
      accepted: {
        count: accepted.length,
        totalPrice: sum(accepted)
      }
    }
  };
}

function createQuotations(): MockQuotation[] {
  return [
    createQuotation(4101, 'O-2026-4101', 'Bouwbedrijf Noord B.V.', 'Bouwplaats Noord', quotation_state.draft, 28450, 21),
    createQuotation(4102, 'O-2026-4102', 'Van Dijk Infra', 'Stationsplein', quotation_state.approved, 46820, 14),
    createQuotation(4103, 'O-2026-4103', 'Aannemersbedrijf De IJssel', 'Kadeversterking', quotation_state.send, 73640, 8),
    createQuotation(4104, 'O-2026-4104', 'Projectontwikkeling Centrum', 'Appartementen Centrum', quotation_state.negotiating, 128900, 42),
    createQuotation(4105, 'O-2026-4105', 'Woningbouw Salland', 'Nieuwbouw Olst', quotation_state.send, 54980, 26),
    createQuotation(4106, 'O-2026-4106', 'Hofman Civiele Techniek', 'Viaduct Oost', quotation_state.accepted, 86420, 63),
    createQuotation(4107, 'O-2026-4107', 'Betonwerken Oost', 'Bedrijfshal Deventer', quotation_state.accepted, 39250, 55),
    createQuotation(4108, 'O-2026-4108', 'Stedelijke Ontwikkeling West', 'Woonwijk West', quotation_state.overdue, 96780, -12),
    createQuotation(4109, 'O-2026-4109', 'Bouwbedrijf Noord B.V.', 'Distributiecentrum Noord', quotation_state.rejected, 62400, 18),
    createQuotation(4110, 'O-2026-4110', 'Van Dijk Infra', 'Rondweg Zuid', quotation_state.cancelled, 33780, 31)
  ];
}

function createQuotation(
  id: number,
  number: string,
  customerName: string,
  projectName: string,
  stateId: number,
  totalPrice: number,
  daysUntilExpiration: number
): MockQuotation {
  return {
    id,
    number,
    customerName,
    projectName,
    stateId,
    totalPrice,
    validToDate: dateWithOffset(daysUntilExpiration),
    daysUntilExpiration
  };
}

function sum(quotations: MockQuotation[]): number {
  let total = 0;

  for(const quotation of quotations)
    total += quotation.totalPrice;

  return Math.round(total * 100) / 100;
}

function dateWithOffset(days: number): string {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + days);
  return [
    String(date.getDate()).padStart(2, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    date.getFullYear()
  ].join('-');
}
